import * as React from "react";
import { Outlet } from "react-router-dom";
import LoggedInNavigation from "./../components/Navigations/LoggedInNavigation";
import {Container, Row, Col} from "react-bootstrap";
import Footer from "../components/Footer";

function DefaultLayout({ backgroundColor = "#fff"}) {
	return (
		<div style={{backgroundColor}} className="d-flex flex-column min-vh-100">
			<LoggedInNavigation hideAuthButton={true} />
			<div className="flex-grow-1" style={{marginBottom: "30px"}}>
				<Outlet/>

			</div>
			<Footer/>
		</div>
	);
}

export default DefaultLayout;
